(function () {
  'use strict';

  var STORAGE_PREFIX = 'hhRewardPopupV1';
  var SHOP_PATH = '/collections/all';
  var REWARD_WEIGHTS = [
    {
      id: 'engraving',
      label: 'Free Engraving',
      code: 'HHENGRAVE',
      note: 'Use this toward custom engraving on eligible collars.',
      weight: 35
    },
    {
      id: 'shipping',
      label: 'Free Shipping',
      code: 'HHFREESHIP',
      note: 'Free standard shipping on your HUND HAUS order.',
      weight: 25
    },
    {
      id: 'trail-glow',
      label: 'Free Trail Glow Upgrade',
      code: 'HHTRAILGLOW',
      note: 'Use this toward a Trail Glow visibility upgrade on eligible collars.',
      weight: 15
    },
    {
      id: 'airtag',
      label: 'Free AirTag Holder',
      code: 'HHAIRTAG',
      note: 'With qualifying collar purchase.',
      weight: 10
    },
    {
      id: 'ten-off',
      label: '10% Off',
      code: 'HHPACK10',
      note: 'Take 10% off your HUND HAUS order.',
      weight: 12
    },
    {
      id: 'fifteen-off',
      label: '15% Off',
      code: 'HHPACK15',
      note: 'Take 15% off your HUND HAUS order.',
      weight: 3
    }
  ];

  var root;
  var lastReward = null;
  var scratchState = null;
  var autoOpened = false;
  var couponObserver = null;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(STORAGE_PREFIX + ':' + key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(STORAGE_PREFIX + ':' + key, value);
    } catch (error) {}
  }

  function storageRemove(key) {
    try {
      window.localStorage.removeItem(STORAGE_PREFIX + ':' + key);
    } catch (error) {}
  }

  function track(eventName, detail) {
    var payload = Object.assign(
      {
        event: eventName,
        source: 'hh_reward_popup'
      },
      detail || {}
    );

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    document.dispatchEvent(
      new CustomEvent('hh:reward-popup:' + eventName.replace(/^hh_reward_/, ''), {
        detail: payload
      })
    );

    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.track) {
      window.ShopifyAnalytics.lib.track(eventName, payload);
    }

    if (window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track(eventName, payload);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function randomHundred() {
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return (values[0] / 4294967296) * 100;
    }
    return Math.random() * 100;
  }

  function rewardById(id) {
    return REWARD_WEIGHTS.find(function (reward) {
      return reward.id === id;
    });
  }

  function pageRewardContext() {
    var path = window.location.pathname.toLowerCase();
    if (path === '/' || path === '' || /^\/collections\/(all|catalog)\/?$/.test(path)) {
      return { type: 'general', allowAll: true };
    }

    var metaTitle = document.querySelector('meta[property="og:title"]');
    var heading = document.querySelector('h1');
    var signature = [
      path,
      document.title,
      metaTitle ? metaTitle.content : '',
      heading ? heading.textContent : ''
    ].join(' ').toLowerCase();

    var hasCollar = /\bcollars?\b|fi gps|fi-compatible|airtag collar|dog collar|trail glow|engraving/.test(signature);
    var hasLeash = /hands[-\s]?free|belt leash|\bleashes?\b|\bleads?\b|walking gear|leash lasso/.test(signature);
    var hasAccessory = /bandana|sling puppy|ball holder|poop bag|toy|accessor/.test(signature);

    if (hasCollar) return { type: 'collar', allowCollarRewards: true };
    if (hasLeash) return { type: 'leash', shippingFallback: true };
    if (hasAccessory) return { type: 'accessory', shippingFallback: true };

    return { type: 'general', allowAll: true };
  }

  function rewardRelevantToContext(reward, context) {
    if (reward.id === 'shipping' || reward.id === 'ten-off' || reward.id === 'fifteen-off') return true;
    if (context.allowAll || context.allowCollarRewards) return true;
    return false;
  }

  function displayRewardsForContext(context) {
    return REWARD_WEIGHTS.filter(function (reward) {
      return rewardRelevantToContext(reward, context);
    });
  }

  function weightedRewardsForContext(context) {
    var shippingFallbackWeight = 0;
    var rewards = [];

    REWARD_WEIGHTS.forEach(function (reward) {
      if (rewardRelevantToContext(reward, context)) {
        rewards.push(Object.assign({}, reward));
        return;
      }
      shippingFallbackWeight += reward.weight;
    });

    if (shippingFallbackWeight > 0) {
      var shippingReward = rewards.find(function (reward) {
        return reward.id === 'shipping';
      });
      if (shippingReward) {
        shippingReward.weight += shippingFallbackWeight;
      } else {
        rewards.push(Object.assign({}, rewardById('shipping'), { weight: shippingFallbackWeight }));
      }
    }

    return rewards.length ? rewards : [Object.assign({}, rewardById('shipping'), { weight: 100 })];
  }

  function chooseReward() {
    var context = pageRewardContext();
    var rewards = weightedRewardsForContext(context);
    var totalWeight = rewards.reduce(function (sum, reward) {
      return sum + reward.weight;
    }, 0);
    var roll = (randomHundred() / 100) * totalWeight;
    var cursor = 0;
    for (var index = 0; index < rewards.length; index += 1) {
      cursor += rewards[index].weight;
      if (roll < cursor) {
        return Object.assign({}, rewards[index], { pageContext: context.type });
      }
    }
    return Object.assign({}, rewards[rewards.length - 1], { pageContext: context.type });
  }

  function rewardListHtml() {
    var context = pageRewardContext();
    return displayRewardsForContext(context).map(function (reward) {
      var label = reward.id === 'airtag' ? reward.label + ' (with qualifying purchase)' : reward.label;
      return '<li>' + escapeHtml(label) + '</li>';
    }).join('');
  }

  function giftIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
      '<path d="M20 12v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 20v-8"/>',
      '<path d="M2.8 7.5h18.4v4.5H2.8z"/>',
      '<path d="M12 7.5v14"/>',
      '<path d="M12 7.4H8.2a2.1 2.1 0 1 1 1.5-3.6C10.9 5 12 7.4 12 7.4z"/>',
      '<path d="M12 7.4h3.8a2.1 2.1 0 1 0-1.5-3.6C13.1 5 12 7.4 12 7.4z"/>',
      '</svg>'
    ].join('');
  }

  function closeIcon() {
    return [
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">',
      '<path d="M6 6l12 12"/>',
      '<path d="M18 6L6 18"/>',
      '</svg>'
    ].join('');
  }

  function mountainIcon() {
    return [
      '<svg class="hh-reward-tag-mountain" viewBox="0 0 160 54" aria-hidden="true" fill="none">',
      '<path d="M8 43 46 13l22 19 15-13 69 24" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>',
      '<path d="m46 13 8 20 14-1m15-13 7 22 12-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" opacity=".55"/>',
      '</svg>'
    ].join('');
  }

  function buildPopup() {
    root = document.createElement('div');
    root.className = 'hh-reward-root';
    root.setAttribute('data-open', 'false');
    root.innerHTML = [
      '<button type="button" class="hh-reward-launcher" aria-label="Open HUND HAUS reward popup">',
      giftIcon(),
      '</button>',
      '<section class="hh-reward-panel" role="dialog" aria-modal="false" aria-labelledby="hh-reward-title">',
      '<button type="button" class="hh-reward-close" aria-label="Close reward popup">',
      closeIcon(),
      '</button>',
      '<div class="hh-reward-step is-active" data-hh-step="entry">',
      '<p class="hh-reward-kicker">H&Uuml;ND HAUS Pack Reward</p>',
      '<h2 class="hh-reward-title" id="hh-reward-title">Every Dog Deserves a Reward</h2>',
      '<p class="hh-reward-copy">Join the H&Uuml;ND HAUS Pack and unlock a special reward.</p>',
      '<ul class="hh-reward-list" aria-label="Available rewards">',
      rewardListHtml(),
      '</ul>',
      '<form class="hh-reward-form" novalidate>',
      '<label class="hh-reward-field-label" for="hh-reward-email">Email</label>',
      '<input class="hh-reward-email" id="hh-reward-email" name="email" type="email" inputmode="email" autocomplete="email" required>',
      '<button type="submit" class="hh-reward-button">Reveal My Reward</button>',
      '<p class="hh-reward-status" role="status" aria-live="polite"></p>',
      '<p class="hh-reward-capture-note">Reward is revealed after email signup.</p>',
      '</form>',
      '</div>',
      '<div class="hh-reward-step" data-hh-step="scratch">',
      '<div class="hh-reward-gift" aria-hidden="true"><span class="hh-reward-gift-lid"></span><span class="hh-reward-gift-box"></span></div>',
      '<div class="hh-reward-tag-wrap">',
      '<div class="hh-reward-tag">',
      '<span class="hh-reward-tag-brand">H&Uuml;ND HAUS</span>',
      mountainIcon(),
      '<div class="hh-reward-under">',
      '<span class="hh-reward-under-label">Reward</span>',
      '<span class="hh-reward-under-value" data-hh-reward-value></span>',
      '</div>',
      '</div>',
      '<canvas class="hh-reward-scratch-canvas" aria-label="Scratch the dog tag to reveal your reward"></canvas>',
      '</div>',
      '<p class="hh-reward-scratch-hint">Scratch the tag to reveal what is waiting underneath.</p>',
      '</div>',
      '<div class="hh-reward-step hh-reward-final" data-hh-step="final">',
      '<p class="hh-reward-kicker">Pack Reward Unlocked</p>',
      '<h2 class="hh-reward-title">Congratulations!</h2>',
      '<p class="hh-reward-copy"><strong data-hh-final-reward></strong></p>',
      '<div class="hh-reward-code" data-hh-final-code></div>',
      '<div class="hh-reward-actions">',
      '<a class="hh-reward-button" href="' + SHOP_PATH + '" data-hh-shop-now>Shop Now</a>',
      '<button type="button" class="hh-reward-button hh-reward-secondary" data-hh-copy-code>Copy Code</button>',
      '</div>',
      '<p class="hh-reward-footnote" data-hh-final-note></p>',
      '</div>',
      '</section>'
    ].join('');

    document.body.appendChild(root);
  }

  function getStep(name) {
    return root.querySelector('[data-hh-step="' + name + '"]');
  }

  function showStep(name) {
    root.querySelectorAll('.hh-reward-step').forEach(function (step) {
      step.classList.toggle('is-active', step.getAttribute('data-hh-step') === name);
    });
  }

  function openPopup(reason) {
    if (!root || root.getAttribute('data-open') === 'true') return;
    root.setAttribute('data-open', 'true');
    autoOpened = true;
    notifyNativeCouponXOpen();
    track('hh_reward_popup_open', { reason: reason || 'manual' });
    var panel = root.querySelector('.hh-reward-panel');
    if (panel) panel.scrollTop = 0;
    window.setTimeout(function () {
      if (window.matchMedia && window.matchMedia('(max-width: 520px), (pointer: coarse)').matches) return;
      var email = root.querySelector('.hh-reward-email');
      if (email && getStep('entry').classList.contains('is-active')) email.focus({ preventScroll: true });
    }, 260);
  }

  function closePopup(reason) {
    if (!root) return;
    root.setAttribute('data-open', 'false');
    storageSet('dismissedUntil', String(Date.now() + 7 * 24 * 60 * 60 * 1000));
    track('hh_reward_popup_close', { reason: reason || 'manual' });
  }

  function canAutoOpen() {
    if (autoOpened) return false;
    var completedUntil = Number(storageGet('completedUntil') || 0);
    if (completedUntil > Date.now()) return false;
    var dismissedUntil = Number(storageGet('dismissedUntil') || 0);
    return dismissedUntil <= Date.now();
  }

  function status(message, isError) {
    var element = root.querySelector('.hh-reward-status');
    if (!element) return;
    element.textContent = message || '';
    element.style.color = isError ? 'var(--hh-reward-error)' : 'var(--hh-reward-forest)';
  }

  function setBusy(isBusy) {
    var button = root.querySelector('.hh-reward-form .hh-reward-button');
    var input = root.querySelector('.hh-reward-email');
    if (button) {
      button.disabled = isBusy;
      button.textContent = isBusy ? 'Revealing...' : 'Reveal My Reward';
    }
    if (input) input.disabled = isBusy;
  }

  function nativeCouponWidgets() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.tab-box.tab-front-box, [id^="tab-box-front-"]')
    );
  }

  function hideNativeCouponX() {
    nativeCouponWidgets().forEach(function (widget) {
      widget.classList.add('hh-reward-native-couponx');
      widget.setAttribute('aria-hidden', 'true');
    });
  }

  function findNativeCouponX() {
    var widgets = nativeCouponWidgets();
    for (var index = 0; index < widgets.length; index += 1) {
      var widget = widgets[index];
      var emailInput = widget.querySelector('input[name="couponapp-email"]');
      var button = widget.querySelector('.coupon-email-button');
      if (emailInput && button) {
        return { widget: widget, input: emailInput, button: button };
      }
    }
    return null;
  }

  function notifyNativeCouponXOpen() {
    var widgets = nativeCouponWidgets();
    for (var index = 0; index < widgets.length; index += 1) {
      var widget = widgets[index];
      if (widget.__hhRewardOpenTracked || widget.classList.contains('couonapp-active')) continue;
      var icon = widget.querySelector('.tab-icon');
      if (!icon) continue;
      widget.__hhRewardOpenTracked = true;
      icon.click();
      hideNativeCouponX();
      return;
    }
  }

  function waitForCouponXSuccess(nativeWidget) {
    return new Promise(function (resolve) {
      var finished = false;
      var timeout = window.setTimeout(function () {
        done(false);
      }, 7000);
      var observer = new MutationObserver(function () {
        if (
          nativeWidget.widget.classList.contains('couponapp-email-coupon-code-show') ||
          !nativeWidget.widget.querySelector('.tab-box-email-content') ||
          nativeWidget.widget.querySelector('.tab-box-couponcode-content[style*="display: block"]')
        ) {
          done(true);
        }
        if (nativeWidget.widget.querySelector('.coupon-email-error')) {
          done(false);
        }
      });

      function done(success) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        observer.disconnect();
        resolve(success);
      }

      observer.observe(nativeWidget.widget, {
        attributes: true,
        childList: true,
        subtree: true
      });
    });
  }

  async function submitCouponX(email, reward) {
    var nativeWidget = findNativeCouponX();
    if (!nativeWidget) return { ok: false, provider: 'couponx-missing' };

    nativeWidget.input.value = email;
    nativeWidget.input.dispatchEvent(new Event('input', { bubbles: true }));
    nativeWidget.input.dispatchEvent(new Event('change', { bubbles: true }));

    if (!nativeWidget.button.getAttribute('data-coupon-code')) {
      nativeWidget.button.setAttribute('data-coupon-code', reward.code);
    }

    var consentId = nativeWidget.button.getAttribute('data-consent-id');
    if (consentId) {
      var consent = document.getElementById(consentId);
      if (consent && consent.required && !consent.checked) consent.checked = true;
    }

    var successPromise = waitForCouponXSuccess(nativeWidget);
    nativeWidget.button.click();
    var success = await successPromise;
    return { ok: success, provider: 'couponx' };
  }

  function customerTags(reward) {
    return [
      'newsletter',
      'hh_reward_popup',
      'hh_reward_' + reward.id,
      'hh_reward_context_' + (reward.pageContext || 'general')
    ].join(',');
  }

  function setFormValue(formData, name, value) {
    if (typeof formData.set === 'function') {
      formData.set(name, value);
      return;
    }
    if (typeof formData.delete === 'function') formData.delete(name);
    formData.append(name, value);
  }

  function findNativeCustomerForm() {
    var forms = Array.prototype.slice.call(document.forms || []);
    for (var index = 0; index < forms.length; index += 1) {
      var form = forms[index];
      if (
        form.querySelector('input[name="form_type"][value="customer"]') &&
        form.querySelector('input[name="contact[email]"]')
      ) {
        return form;
      }
    }
    return null;
  }

  function normalizedContactAction(action) {
    try {
      var url = new URL(action || '/contact#contact_form', window.location.origin);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return '/contact#contact_form';
    }
  }

  function customerCapturePayload(email, reward) {
    var nativeForm = findNativeCustomerForm();
    var formData = nativeForm ? new FormData(nativeForm) : new FormData();

    setFormValue(formData, 'form_type', 'customer');
    if (!formData.has || !formData.has('utf8')) setFormValue(formData, 'utf8', '\u2713');
    setFormValue(formData, 'contact[email]', email);
    setFormValue(formData, 'contact[tags]', customerTags(reward));

    return {
      action: normalizedContactAction(nativeForm ? nativeForm.getAttribute('action') : ''),
      formData: formData
    };
  }

  function appendHiddenInput(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function submitShopifyCustomerFrame(payload) {
    return new Promise(function (resolve) {
      var frameName = 'hh-reward-capture-' + Date.now();
      var iframe = document.createElement('iframe');
      var form = document.createElement('form');
      var settled = false;
      var submitted = false;
      var timeout;

      function cleanup() {
        window.clearTimeout(timeout);
        window.setTimeout(function () {
          if (form.parentNode) form.parentNode.removeChild(form);
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 500);
      }

      function done(ok) {
        if (settled) return;
        settled = true;
        cleanup();
        resolve({ ok: ok, provider: 'shopify-customer-form' });
      }

      iframe.name = frameName;
      iframe.title = 'HUND HAUS reward email capture';
      iframe.style.display = 'none';
      iframe.addEventListener(
        'load',
        function () {
          if (!submitted) return;
          done(true);
        }
      );

      form.method = 'post';
      form.action = payload.action;
      form.target = frameName;
      form.acceptCharset = 'UTF-8';
      form.style.display = 'none';

      payload.formData.forEach(function (value, key) {
        if (typeof value === 'string') appendHiddenInput(form, key, value);
      });

      document.body.appendChild(iframe);
      document.body.appendChild(form);
      timeout = window.setTimeout(function () {
        done(true);
      }, 2500);

      try {
        submitted = true;
        form.submit();
      } catch (error) {
        done(false);
      }
    });
  }

  async function submitShopifyCustomer(email, reward) {
    var payload = customerCapturePayload(email, reward);

    try {
      var response = await fetch(payload.action, {
        method: 'POST',
        body: payload.formData,
        credentials: 'include',
        redirect: 'follow',
        headers: {
          Accept: 'text/html,application/xhtml+xml'
        }
      });

      if (response.ok || response.redirected || response.status === 422) {
        return { ok: true, provider: 'shopify-customer', status: response.status };
      }
    } catch (error) {}

    return submitShopifyCustomerFrame(payload);
  }

  async function captureEmail(email, reward) {
    try {
      var couponResult = await submitCouponX(email, reward);
      if (couponResult.ok) return couponResult;
    } catch (error) {}

    return submitShopifyCustomer(email, reward);
  }

  function renderScratchReward(reward) {
    root.querySelector('[data-hh-reward-value]').textContent = reward.label;
    showStep('scratch');
    setupScratchCanvas(reward);
  }

  function setupScratchCanvas(reward) {
    var canvas = root.querySelector('.hh-reward-scratch-canvas');
    if (!canvas) return;

    scratchState = {
      canvas: canvas,
      reward: reward,
      drawing: false,
      started: false,
      complete: false
    };

    sizeScratchCanvas();

    canvas.addEventListener('pointerdown', scratchStart);
    canvas.addEventListener('pointermove', scratchMove);
    canvas.addEventListener('pointerup', scratchEnd);
    canvas.addEventListener('pointercancel', scratchEnd);
    canvas.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        finishScratch();
      }
    });
    canvas.tabIndex = 0;

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        if (!scratchState || scratchState.complete) return;
        sizeScratchCanvas();
      });
      resizeObserver.observe(canvas);
      scratchState.resizeObserver = resizeObserver;
    }
  }

  function sizeScratchCanvas() {
    if (!scratchState) return;
    var canvas = scratchState.canvas;
    var rect = canvas.getBoundingClientRect();
    var ratio = Math.max(1, window.devicePixelRatio || 1);
    canvas.width = Math.max(1, Math.round(rect.width * ratio));
    canvas.height = Math.max(1, Math.round(rect.height * ratio));
    var context = canvas.getContext('2d');
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    drawScratchSurface(context, rect.width, rect.height);
  }

  function drawScratchSurface(context, width, height) {
    var gradient = context.createLinearGradient(0, 0, width, height);
    gradient.addColorStop(0, '#d7d1c6');
    gradient.addColorStop(0.42, '#9f978b');
    gradient.addColorStop(1, '#ede7dc');
    context.globalCompositeOperation = 'source-over';
    context.clearRect(0, 0, width, height);
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);

    context.globalAlpha = 0.2;
    context.strokeStyle = '#ffffff';
    for (var light = -height; light < width; light += 18) {
      context.beginPath();
      context.moveTo(light, height);
      context.lineTo(light + height, 0);
      context.stroke();
    }

    context.globalAlpha = 0.16;
    context.strokeStyle = '#2f2a23';
    for (var dark = -height; dark < width; dark += 23) {
      context.beginPath();
      context.moveTo(dark, 0);
      context.lineTo(dark + height, height);
      context.stroke();
    }

    context.globalAlpha = 0.82;
    context.fillStyle = '#3d372f';
    context.font = '700 14px Montserrat, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText('SCRATCH TO REVEAL', width / 2 + 8, height / 2 + 18);
    context.globalAlpha = 1;
  }

  function scratchPoint(event) {
    var canvas = scratchState.canvas;
    var rect = canvas.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top
    };
  }

  function eraseAt(point) {
    if (!scratchState || scratchState.complete) return;
    var canvas = scratchState.canvas;
    var context = canvas.getContext('2d');
    var rect = canvas.getBoundingClientRect();
    var brush = Math.max(24, Math.min(rect.width, rect.height) * 0.15);
    context.globalCompositeOperation = 'destination-out';
    context.beginPath();
    context.arc(point.x, point.y, brush, 0, Math.PI * 2);
    context.fill();
    context.globalCompositeOperation = 'source-over';
  }

  function scratchStart(event) {
    if (!scratchState || scratchState.complete) return;
    scratchState.drawing = true;
    scratchState.canvas.setPointerCapture(event.pointerId);
    if (!scratchState.started) {
      scratchState.started = true;
      track('hh_reward_scratch_start', { reward: scratchState.reward.id });
    }
    eraseAt(scratchPoint(event));
  }

  function scratchMove(event) {
    if (!scratchState || !scratchState.drawing || scratchState.complete) return;
    event.preventDefault();
    eraseAt(scratchPoint(event));
    if (scratchPercent() > 0.3) finishScratch();
  }

  function scratchEnd() {
    if (!scratchState) return;
    scratchState.drawing = false;
    if (!scratchState.complete && scratchPercent() > 0.18) finishScratch();
  }

  function scratchPercent() {
    if (!scratchState) return 0;
    var canvas = scratchState.canvas;
    var context = canvas.getContext('2d');
    var width = canvas.width;
    var height = canvas.height;
    var pixels = context.getImageData(0, 0, width, height).data;
    var total = 0;
    var clear = 0;
    for (var index = 3; index < pixels.length; index += 64) {
      total += 1;
      if (pixels[index] < 24) clear += 1;
    }
    return total ? clear / total : 0;
  }

  function finishScratch() {
    if (!scratchState || scratchState.complete) return;
    scratchState.complete = true;
    var canvas = scratchState.canvas;
    canvas.style.transition = 'opacity 520ms ease';
    canvas.style.opacity = '0';
    if (scratchState.resizeObserver) scratchState.resizeObserver.disconnect();
    window.setTimeout(function () {
      showFinal(scratchState.reward);
    }, 680);
  }

  function showFinal(reward) {
    root.querySelector('[data-hh-final-reward]').textContent = reward.label;
    root.querySelector('[data-hh-final-code]').textContent = reward.code;
    root.querySelector('[data-hh-final-note]').textContent = reward.note;
    showStep('final');
    storageSet('completedUntil', String(Date.now() + 30 * 24 * 60 * 60 * 1000));
    storageRemove('dismissedUntil');
    track('hh_reward_revealed', {
      reward: reward.id,
      reward_label: reward.label,
      reward_context: reward.pageContext || 'general',
      coupon_code: reward.code
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();
    status('', false);

    var emailInput = root.querySelector('.hh-reward-email');
    var email = emailInput ? emailInput.value.trim() : '';

    if (!isValidEmail(email)) {
      status('Enter a valid email address to reveal your reward.', true);
      if (emailInput) emailInput.focus();
      return;
    }

    var reward = chooseReward();
    lastReward = reward;
    setBusy(true);

    try {
      var result = await captureEmail(email, reward);
      if (!result || !result.ok) {
        throw new Error('Email capture failed');
      }

      storageSet(
        'lastReward',
        JSON.stringify({
          reward: reward.id,
          code: reward.code,
          email: email,
          provider: result.provider,
          reward_context: reward.pageContext || 'general',
          timestamp: Date.now()
        })
      );

      track('hh_reward_email_submitted', {
        provider: result.provider,
        reward: reward.id,
        reward_context: reward.pageContext || 'general',
        coupon_code: reward.code
      });
      renderScratchReward(reward);
    } catch (error) {
      status('We could not capture that email. Please try again.', true);
      setBusy(false);
    }
  }

  function copyCode() {
    if (!lastReward) return;
    var code = lastReward.code;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(function () {});
    }
    track('hh_reward_code_copy', {
      reward: lastReward.id,
      coupon_code: code
    });
  }

  function bindEvents() {
    root.querySelector('.hh-reward-launcher').addEventListener('click', function () {
      openPopup('launcher');
    });
    root.querySelector('.hh-reward-close').addEventListener('click', function () {
      closePopup('close_button');
    });
    root.querySelector('.hh-reward-form').addEventListener('submit', handleSubmit);
    root.querySelector('[data-hh-copy-code]').addEventListener('click', copyCode);
    root.querySelector('[data-hh-shop-now]').addEventListener('click', function () {
      track('hh_reward_shop_now', lastReward ? { reward: lastReward.id, coupon_code: lastReward.code } : {});
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.getAttribute('data-open') === 'true') closePopup('escape');
    });
  }

  function setupTriggers() {
    window.setTimeout(function () {
      if (canAutoOpen()) openPopup('delay');
    }, 4500);

    window.addEventListener(
      'scroll',
      function () {
        if (!canAutoOpen()) return;
        var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        var percent = window.scrollY / scrollable;
        if (percent > 0.42) openPopup('scroll');
      },
      { passive: true }
    );

    document.addEventListener('mouseleave', function (event) {
      if (window.innerWidth < 900) return;
      if (event.clientY <= 0 && canAutoOpen()) openPopup('exit_intent');
    });
  }

  function observeCouponX() {
    hideNativeCouponX();
    couponObserver = new MutationObserver(function () {
      hideNativeCouponX();
    });
    couponObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    if (window.__hhRewardPopupLoaded) return;
    window.__hhRewardPopupLoaded = true;
    buildPopup();
    bindEvents();
    observeCouponX();
    setupTriggers();
    track('hh_reward_popup_ready');
  }

  ready(init);
})();
